import React from 'react';
import { Stars } from '../../components/Stars/Stars';

import styles from '../../components/Stats/Stats.module.scss';

export type StatsProps = {
  accessibilityScore: number;
  facilitiesScore: number;
  numberOfReviews: number;
  priceScore: number;
  rangeFacilityScore: number;
  score: number;
  serviceScore: number;
};

export const Stats: React.FC<StatsProps> = ({
  accessibilityScore,
  facilitiesScore,
  numberOfReviews,
  priceScore,
  rangeFacilityScore,
  score,
  serviceScore,
}) => {
  return (
    <>
      <div className={styles['stats__summary']}>
        <Stars size="large" value={score} />
        <span className={styles['stats__avg-review']}>{score.toFixed(1)}</span>
        <span className={styles['stats__count']}>{numberOfReviews} reviews</span>
      </div>
      <ul className={styles['stats__list']}>
        <li className={styles['stats__list-item']}>
          <div className={styles['stats__list-title']}>Accessibility</div>
          <div>
            <span className={styles['stats__list-stars']}>
              <Stars color="tertiary" showValue={false} value={accessibilityScore} />
            </span>
            <span className={styles['stats__list-score']}>{accessibilityScore.toFixed(1)}</span>
          </div>
        </li>
        <li className={styles['stats__list-item']}>
          <div className={styles['stats__list-title']}>Price</div>
          <div>
            <span className={styles['stats__list-stars']}>
              <Stars color="tertiary" showValue={false} value={priceScore} />
            </span>
            <span className={styles['stats__list-score']}>{priceScore.toFixed(1)}</span>
          </div>
        </li>
        <li className={styles['stats__list-item']}>
          <div className={styles['stats__list-title']}>Facilities available</div>
          <div>
            <span className={styles['stats__list-stars']}>
              <Stars color="tertiary" showValue={false} value={facilitiesScore} />
            </span>
            <span className={styles['stats__list-score']}>{facilitiesScore.toFixed(1)}</span>
          </div>
        </li>
        <li className={styles['stats__list-item']}>
          <div className={styles['stats__list-title']}>Range of facilities</div>
          <div>
            <span className={styles['stats__list-stars']}>
              <Stars color="tertiary" showValue={false} value={rangeFacilityScore} />
            </span>
            <span className={styles['stats__list-score']}>{rangeFacilityScore.toFixed(1)}</span>
          </div>
        </li>
        <li className={styles['stats__list-item']}>
          <div className={styles['stats__list-title']}>Customer service</div>
          <div>
            <span className={styles['stats__list-stars']}>
              <Stars color="tertiary" showValue={false} value={serviceScore} />
            </span>
            <span className={styles['stats__list-score']}>{serviceScore.toFixed(1)}</span>
          </div>
        </li>
      </ul>
    </>
  );
};
